import { useContext, useEffect, useState } from 'react';
import ModalContext from '~/context/vdp/ModalContext';

/**
 * Hook that detects any scroll movement on the page
 * Returns true when user has scrolled away from the very top (scrollY > 0)
 * Returns false when user is at the very top (scrollY === 0)
 *
 * Skips the scroll listener while any modal is open — mobile modal body-scroll
 * locks can force window.scrollY to 0, which would otherwise be mistaken for
 * the user scrolling to the top of the page.
 */
export const useScrollDetection = () => {
  const { isAnyModalOpen } = useContext(ModalContext);

  // Initialize with actual scroll position to prevent flash
  const [hasScrolled, setHasScrolled] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.scrollY > 0;
    }

    return false;
  });

  useEffect(() => {
    if (isAnyModalOpen) return;

    const handleScroll = () => {
      setHasScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isAnyModalOpen]);

  return hasScrolled;
};
